import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { ProductVariantAttributeFormDialog } from "../product-variant-attribute-form-dialog";

import { Button } from "@mui/material";

export const AddProductVariantAttributeFormDialog = ({
  isOpen,
  onClose,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.post("product-variant-attributes", {
        name,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan atribut varian produk"));

      throw error;
    }
  };

  return (
    <ProductVariantAttributeFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Tambah Atribut Varian Produk"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddProductVariantAttributeFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
